import { render, staticRenderFns } from "./insured-tab.vue?vue&type=template&id=f71f5576&"
import script from "./insured-tab.vue?vue&type=script&lang=js&"
export * from "./insured-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports